import {withRouter} from 'react-router';
import ActiveLink from './ActiveLink';


const ActiveLinkContainer = withRouter(ActiveLink, {withRef: false});

export default ActiveLinkContainer;
